import { lazy } from 'react';

/** Открывает экран планировщика */
export const SchedulerPageAsync = lazy(() => import('./SchedulerPage'));
